module.exports = __webpack_public_path__ + "img/finland-tuberculosis-female.c2326552.png";